import React from "react";
import * as Scrivito from "scrivito";
import { getHomepage } from "utils";
import { NavConfigurator } from "./index";

export const Navigation = Scrivito.connect(({ device }: { device: string }) => {
  const homepage = getHomepage();
  if (!homepage) {
    return null;
  }

  return <NavConfigurator homepage={homepage} device={device} />;
});
